import { css } from 'styled-components';

export const SimpleListTable = css`
  .ant-table {
    border: 1px solid var(--line-gray);
    border-radius: 0;
  }

  .ant-table-container {
    border-inline-start: 0 !important;
  }

  .ant-table-thead > tr > th {
    background: var(--background-gray);
    color: var(--text-secondary);
    font-family: var(--font-bold);
    font-size: 12px;
    text-transform: uppercase;
    letter-spacing: 0.03em;
    border-bottom: 1px solid var(--line-gray);
  }

  .ant-table-tbody > tr > td {
    background: transparent;
    border-bottom: 1px solid var(--line-gray);
    font-size: 14px;
    color: var(--text-primary);
    height: 42px;
  }

  .ant-table-tbody > tr,
  .ant-table-tbody > tr:nth-child(odd),
  .ant-table-tbody > tr:nth-child(even),
  .ant-table-tbody > tr:hover > td,
  .ant-table-tbody > tr > td.ant-table-cell-row-hover {
    background: transparent !important;
  }

  .ant-table-tbody > tr:last-child > td {
    border-bottom: 0;
  }

  .ant-table-cell::before {
    display: none;
  }
`;
